export default __webpack_public_path__ + "static/media/70.ba7b7291.jpeg";